import React, { useCallback, useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Auth from "./pages/Auth/Auth";
import Home from "./pages/Home/Home";
import ProfileInterface from "./pages/ProfileInterface/profile-interface";
import VIPClub from "./pages/VipClub";
import AmountEntry from "./pages/DepositAmount/amount-entry";
import DocumentsUpload from "./pages/DocumentsUpload/DocumentsUpload";
import TransactionProgress from "./pages/TransactionProgress";
import TransactionRecords from "./pages/TransactionRecords";
import TransactionDetails from "./pages/TransactionDetails";
import QuickDeposit from "./pages/QuickDeposit/QuickDeposit";
import ReferralProgram from "./pages/ReferralProgram/ReferralProgram";
import "./styles/global.css";
// import CompleteSlotsUI from "./pages/CompleteSlots/CompleteSlots";
import GamesCasino from "./pages/GamesCasino";
import Menu from "./pages/Menu";
import Deposit from "./pages/Deposit";
import Withdrawal from "./pages/Withdrawal";
import Turnover from "./pages/TurnoverList";
import Notifications from "./pages/Notifications";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import ReportProfile from "./pages/ReportProfile";
import Promotions from "./pages/Promotions";
import PromotionDetail from "./pages/PromotionDetail";
import EWallet from "./pages/EWallet";
import BrandAmbassadors from "./components/BrandAmbassadors/BrandAmbassadors";
import BrandAmbassadorDetail from "./pages/BrandAmbassadorDetail";
import LocalDepositAmount from "./pages/LocalDepositAmount/amount-entry";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import APIS from "./common/apis";
import GameRun from "./common/GameRun";
import BettingRecords from "./pages/BettingRecords";
import BettingDetails from "./pages/BettingDetails";
import ForgotPassword from "./pages/ForgotPassword";
import MyVIP from "./pages/MyVIP/MyVIP";
import VIPRebateScreen from "./pages/VIPRebateScreen/VIPRebateScreen";
import Personal from "./pages/Personal/Personal";
import TopInstallBanner from "./components/TopInstallBanner";
import FreeEvent from "./pages/FreeEvent/FreeEvent";
import RewardPage from "./pages/RewardPage/RewardPage";
import TermAndCondition from "./pages/TermAndCondition";
import ContactUs from "./pages/ContactUs/ContactUs";
import AboutUs from "./pages/AboutUs";
import Affiliate from "./pages/Affiliate/Affiliate";
import LanguageModal from "./components/LanguageModal";
import VipBonus from "./pages/VipBonus/VipBonus";
import BasicInformation from "./pages/BasicInformation/BasicInformation";
import CenterTransfer from "./pages/CenterTransfer/CenterTransfer";
import BetRecords from "./pages/BetRecords/BetRecords";
import StatementRecords from "./pages/StatementRecords/StatementRecords";
import MessageBox from "./components/MessageBox";
import PromoFreeList from "./pages/PromoFreeList/PromoFreeList";
import Signin from "./pages/Signin/Signin";
import LoginModal from "./components/LoginModal/LoginModal";
import EXHome from "./components/EXHome";


const isMobile = () => /Mobi|Android/i.test(navigator.userAgent);
function App() {

  const [showModalLogin, setShowModalLogin] = useState(false);
  const isDeviceMobile = isMobile();
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [showContent, setShowContent] = useState(false);
  const [logo, setLogo] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [globalData, setGlobalData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [balance, setBalance] = useState(0);
  const [refreshPvtData, setRefreshPvtData] = useState(false);

  // using useEffect on load, get the css from a api and inject it into the document head
  //   useEffect(() => {
  // 	const fetchCss = async () => {
  // 		try {
  // 			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/css`);
  // 			if (response.ok) {
  // 				const cssText = await response.text();
  // 				const styleElement = document.createElement("style");
  // 				styleElement.textContent = cssText;
  // 				document.head.appendChild(styleElement);
  // 			}
  // 		} catch (error) {
  // 			console.error("Error fetching CSS:", error);
  // 		}
  // 	};
  // 	fetchCss();
  // }, []);

  // Function to show alert messages

  const showAlert = (message = false) => {
    if (!message) {
      setShowModal(false);
      return;
    }
    setShowModal(true);
    setModalMessage(message);
  };

  // Function to dynamically set the favicon
  const setFavicon = (url) => {
    if (!url) return;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = url;
  };
  const [cssLoading, setCssLoading] = useState(false);

  // Fetch promotions data and set logo & favicon
  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/logo`,
        );
        if (!response.ok) {
          throw new Error("Failed to fetch promotions");
        }
        const data = await response.json();
        setLogo(data[0].loader_logo);
        if (data[0]?.favicon) {
          setFavicon(
            `${process.env.REACT_APP_API_URL}/storage/${data[0].favicon}`,
          );
        }
        console.log(data[0].loader_logo);
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };

    fetchPromotions();
  }, []);

  // Fetch general site data
  useEffect(() => {
    const fetchGeneral = async () => {
      let token = localStorage.getItem("token");
      let headers = {
        Authorization: `Bearer ${token}`,
      };
      if (!token) {
        headers = {};
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/general`,
          {
            headers: headers,
          },
        );
        if (!response.ok) {
          throw new Error("Failed to fetch General");
        }
        const data = await response.json();
        if (data) {
          document.title = data[0].site_title;
          localStorage.setItem("whatsapp", data[0].whatsapp);
          localStorage.setItem("liveChat", data[0].live_chat);
          localStorage.setItem("intercom", data[0].intercom);
          localStorage.setItem("tawkId", data[0]?.tawk_id);
        }
      } catch (error) {
        console.error("Error fetching General:", error);
      }
    };

    fetchGeneral();
  }, []);

  // Monitor when both API calls are finished
  useEffect(() => {
    if (logo && document.title) {
      setIsDataLoaded(true);
    }
  }, [logo]);

  const fetchBalance = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/balance`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (response.ok) {
          const data = await response.json();

          localStorage.setItem("balance", data.balance);
          if (document.querySelector(".mainBalance")) {
            document.querySelector(".mainBalance").innerHTML = data.balance;
          }
        } else if (response.status === 401) {
          handleLogout();
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    } else {
      console.warn("No token found in local storage.");
    }
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    window.location.href = "/";
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchBalance();
      const interval = setInterval(fetchBalance, 10000);
      return () => clearInterval(interval);
    }
  }, [isLoggedIn, fetchBalance]);
  const PrivateRoute = ({ element }) => {
    return isLoggedIn ? element : <Navigate to="/" />;
  };
  // const PrivateRoute = ({ element }) => {
  //   useEffect(() => {
  //     if (!isLoggedIn) {
  //       setShowModalLogin(true);
  //     }
  //   }, [isLoggedIn]);

  //   return isLoggedIn ? element : null;
  // };
  // Add this above your App component or inside it
  const PublicRoute = ({ element }) => {
    return !isLoggedIn ? element : <Navigate to="/home" replace />;
  };
  // const [open, setOpen] = useState(true);
  // const [lang, setLang] = useState("en");

  return (
    <Router>
      {/* <LanguageModal
      isOpen={open}
      onClose={() => setOpen(false)}
      selectedLanguage={lang}
      onSelectLanguage={(selected) => {
        setLang(selected);
        setOpen(false);
      }}
    /> */}
      <div className="App">
        <TopInstallBanner
          onInstallWebApp={() => console.log("Install Web App")}
          onDownloadApp={() => console.log("Download App")}
          onClose={() => console.log("Banner closed")}
        />
        <APIS setGlobalData={setGlobalData} refreshPvtData={refreshPvtData} />
        <ToastContainer />
        <Routes>
          {/* Auth Routes */}
          <Route
            path="/brandAmbassador-detail"
            element={<BrandAmbassadorDetail />}
          />
          <Route path="/brandAmbassadors" element={<BrandAmbassadors />} />
          <Route path="/e-wallet" element={<EWallet />} />
          <Route path="/promotions-detail" element={<PromotionDetail />} />
          {/* <Route path="/promotions" element={<Promotions />} /> */}
          <Route
            path="/promotions"
            element={
              <Promotions
                promotions={globalData.promotions?.allPromotions || []}
              />
            }
          />
          <Route
            path="/promo_free"
            element={
              <Promotions
                promotions={globalData.promotions?.allPromotions || []}
              />
            }
          />
          <Route
            path="/promotions"
            element={
              <Promotions
                promotions={globalData.promotions?.allPromotions || []}
              />
            }
          />
          <Route
            path="/free-event"
            element={
              <FreeEvent
                promotions={globalData.promotions?.allPromotions || []}
              />
            }
          />
          <Route path="/basic-information" element={<BasicInformation globalData={globalData}/>} />
          <Route path="/report-profile" element={<ReportProfile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/forget-password" element={<ForgotPassword />} />
          <Route path="/reward-page" element={<RewardPage />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/vip-bonus" element={<VipBonus />} />
          <Route path="/promo-free-list" element={<PromoFreeList promotions={globalData.promotions?.allPromotions || []}/>} />
          <Route path="/daily-login-bonus" element={<Signin />} />
          <Route path="/contact-us" element={<ContactUs
            globalData={globalData}
            sociallink={globalData.socialLinks || {}}
            
          />} />

          <Route path="/terms" element={<TermAndCondition />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route
            path="/turnover-checking"
            element={<Turnover turnovers={globalData.turnovers || []} />}
          />
          {/* <Route path="/login" element={<PublicRoute element={<Auth />} />} /> */}
          <Route
            path="/register"
            element={<PublicRoute element={<Auth />} />}
          />
          <Route path="/withdrawal" element={<Withdrawal general={globalData.general}
            hasEWallet={globalData.hasEWallet}
            userData={globalData.userData || []}
            transactionData={globalData.transactions || []}
            items={globalData.paymentMethods || []} />} />

          {/* Main Routes */}
          <Route
            path="/home"
            element={
              <Home featuredGames={globalData.sliders?.feature || []} globalData={globalData} userData={globalData.userData} />
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute
                element={
                  <ProfileInterface
                    fetchBalance={fetchBalance}
                    userData={globalData.userData}
                    general={globalData.general || {}}
                  />
                }
              />
            }
          />
          <Route
            path="/betting-records"
            element={
              <PrivateRoute
                element={
                  <BettingRecords
                  // fetchBalance={fetchBalance}
                  // userData={globalData.userData}
                  // general={globalData.general || {}}
                  />
                }
              />
            }
          />
          <Route
            path="/betting-details"
            element={
              <PrivateRoute
                element={
                  <BettingDetails
                  // fetchBalance={fetchBalance}
                  // userData={globalData.userData}
                  // general={globalData.general || {}}
                  />
                }
              />
            }
          />
          <Route path="/menu" element={<Menu sociallink={globalData.socialLinks || {}} promotions={globalData.promotions?.allPromotions || []} featuredGames={globalData.sliders?.feature || []} />} />

          <Route
            path="/vip-club"
            element={<PrivateRoute element={<VIPClub />} />}
          />
          <Route
            path="/vip-point"
            element={<PrivateRoute element={<MyVIP userData={globalData.userData} />} />}
          />
          <Route
            path="/vip-rebate"
            element={<PrivateRoute element={<VIPRebateScreen />} />}
          />
          <Route
            path="/personal"
           element={<Personal  userData={globalData.userData || []}/>}
          />
          {/* VIP & Deposits */}
          {/* <Route path="/vip-club" element={<VIPClub />} /> */}
          {/* <Route path="/withdrawal-entry" element={<AmountEntry />} /> */}
          <Route
            path="/withdrawal-entry"
            element={
              <AmountEntry
                general={globalData.general}
                hasEWallet={globalData.hasEWallet}
                userData={globalData.userData || []}
                transactionData={globalData.transactions || []}
                items={globalData.paymentMethods || []}
              />
            }
          />

          {/* <Route path="/local-wallet" element={<LocalDepositAmount />} /> */}
          <Route
            path="/local-wallet"
            element={
              <LocalDepositAmount
                usdtRate={globalData?.general?.usdt_rate}
                hasEWallet={globalData.hasEWallet}
                userData={globalData.userData || []}
                transactionData={globalData.transactions || []}
                items={globalData.paymentMethods || []}
                promotions={globalData.promotions?.activePromotion || []}
              />
            }
          />
          <Route path="/deposit" element={<Deposit usdtRate={globalData?.general?.usdt_rate}
            hasEWallet={globalData.hasEWallet}
            userData={globalData.userData || []}
            transactionData={globalData.transactions || []}
            items={globalData.paymentMethods || []}
            promotions={globalData.promotions?.activePromotion || []} />} />
          <Route
            path="/quick-deposit"
            element={
              <QuickDeposit
                usdtRate={globalData?.general?.usdt_rate}
                hasEWallet={globalData.hasEWallet}
                userData={globalData.userData || []}
                transactionData={globalData.transactions || []}
                items={globalData.paymentMethods || []}
                promotions={globalData.promotions?.activePromotion || []}
              />
            }
          />

          {/* Transactions */}
          <Route
            path="/transactions"
            element={
              <TransactionRecords
                setRefreshPvtData={setRefreshPvtData}
                transactionData={globalData.transactions || []}
              />
            }
          />
          <Route path="/center-transfer" element={<CenterTransfer />} />
          <Route path="/bet-reports" element={<BetRecords />} />
          <Route path="/statements" element={<StatementRecords  transactionData={globalData.transactions || []}/>} />
          <Route path="/notice" element={<MessageBox />} />
          <Route path="/gamerun" element={<GameRun />} />
          <Route path="/transaction-detail" element={<TransactionDetails />} />
          {/* <Route path="/betting-record" element={<BettingRecord />} /> */}
          <Route
            path="/transaction-progress"
            element={<TransactionProgress />}
          />

          {/* Documents & Referrals */}
          <Route path="/documents" element={<DocumentsUpload />} />
          <Route
            path="/referral-program"
            element={
              <ReferralProgram
                showAlert={showAlert}
                userData={globalData.userData}
              />
            }
          />
<Route path="/exchange" element={
            <PrivateRoute element={<EXHome />} />} />
          <Route
            path="/casino"
            element={<GamesCasino globalData={globalData} />}
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/home" replace />} />

          {/* 404 - Not Found */}
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
        {/* <div className="betdet-footer">
        <div className="betdet-logo">
          <span className="betdet-logo-text">bj</span>
        </div>
      </div> */}
      </div>
      <LoginModal
        isOpen={showModalLogin}
        onClose={() => setShowModalLogin(false)}
        onLogin={(data) => console.log("login data:", data)}
        onRegister={() => console.log("register")}
        onForgotPassword={() => console.log("forgot password")}
      />
    </Router>
  );
}

export default App;